export const STORAGE_NAMESPACE = 'PREBOOKING';

export const LOUNGE_CODE = 'LOUNGE_CODE';
export const BOOKING_ID = 'BOOKING_ID';
export const ENTRY_URL = 'ENTRY_URL';
export const LANGUAGE = 'LANGUAGE';
export const JWT = 'JWT';
export const REFERRER = 'REFERRER';
export const PLATFORM = 'PLATFORM';
export const VERSION = 'VERSION';
export const BOOKING_MODE_STATE = 'MODE';
export const ORIGINAL_BOOKING_DETAILS = 'ORIGINAL_BOOKING_DETAILS';
export const USER_ID = 'xx';
export const ENTITLEMENTS = 'ENTITLEMENTS';
export const IS_USER_VALIDATED = 'IS_USER_VALIDATED';
export const NEW_MEMBERSHIP_ENROLLED = 'NEW_MEMBERSHIP_ENROLLED';
export const SESSION_ID = 'SESSION_ID';
export const IS_LOCATION_PRODUCT = 'IS_LOCATION_PRODUCT';
export const FT_ALWAYS_AVAILABLE = 'FT_ALWAYS_AVAILABLE';
export const PRODUCT = 'PRODUCT';
export const PAYLOAD = 'PAYLOAD';
export const FASTTRACK_CONSENT_ACCEPTED = 'USER_INFO';

// Datadog
export const LOG_DATA_PAYLOAD = 'LOG_DATA_PAYLOAD';
export const LOG_DATA_USER_FLOW = 'LOG_DATA_USER_FLOW';
export const LOG_DATA_ACCOUNT_TYPE = 'LOG_DATA_ACCOUNT_TYPE';
export const LOG_DATA_BOOKING = 'LOG_DATA_BOOKING';
export const LOG_DATA_USER_ACCOUNT = 'LOG_DATA_USER_ACCOUNT';
export const LOG_DATA_PRODUCT = 'LOG_DATA_PRODUCT';
export const LOG_DATA_DEVICE_ID = 'LOG_DATA_DEVICE_ID';
export const LOG_DATA_SESSION_INIT_ID = 'LOG_DATA_SESSION_INIT_ID';
export const LOG_DATA_USER_SESSION = 'LOG_DATA_USER_SESSION';
export const LOG_DATA_PAGE_NAME = 'LOG_DATA_PAGE_NAME';
export const LOG_DATA_CLIENT = 'LOG_DATA_CLIENT';
export const LOG_INITIATE_USER_FLOW_FIRED = 'LOG_INITIATE_USER_FLOW_FIRED';
export const LOG_FUNNEL_EMITTED_ACTIONS = 'LOG_FUNNEL_EMITTED_ACTIONS';
export const LOG_ACTION_PATH = 'LOG_ACTION_PATH';
